import { AccountStatus } from '@/swagger/constants/anagraphics-enums';
import { ClusterType } from '@/swagger/constants/credits-enums';
import { DepartmentTeamDetails } from '../types';

export const MOCK_RESPONSE_GET_DEPARTMENTS = {
  data: [
    {
      id: 'dept-1',
      name: 'Human Resources',
      teams: ['Team 1', 'Team 2'],
      totalEmployees: 25,
      manager: {
        employeeId: 'mgr-1',
        firstName: 'Alice',
        lastName: 'Johnson',
        email: 'alice.johnson@example.com',
      },
    },
  ],
};

export const MOCK_RESPONSE_GET_DEPARTMENT_TEAMS = {
  department: {
    id: 'dept-1',
    name: 'Human Resources',
    manager: {
      id: 'mgr-1',
      employeeId: 'mgr-1',
      firstName: 'Alice',
      lastName: 'Johnson',
      email: 'alice.johnson@example.com',
      status: AccountStatus.ENABLED,
    },
    totalEmployees: 25,
  },
  data: [
    {
      id: 'dept-1',
      name: 'Human Resources',
      manager: {
        id: 'mgr-1',
        employeeId: 'mgr-1',
        firstName: 'Alice',
        lastName: 'Johnson',
        email: '',
        status: AccountStatus.ENABLED,
      },
      totalEmployees: 24,
    },
  ],
};

export const MOCK_RESPONSE_GET_DEPARTMENT_TEAM_MEMBERS = {
  data: [
    {
      id: 'emp-1',
      firstName: 'John',
      lastName: 'Doe',
      role: 'Developer',
      email: 'john.doe@example.com',
      status: AccountStatus.ENABLED,
    },
    {
      id: 'emp-2',
      firstName: 'Jane',
      lastName: 'Smith',
      role: 'Designer',
      email: 'jane.smith@example.com',
      status: AccountStatus.ENABLED,
    },
  ],
  totalItems: 2,
};

export const MOCK_RESPONSE_GET_DEPARTMENT_MEMBERS = [
  {
    id: 'emp-1',
    firstName: 'John',
    lastName: 'Doe',
    role: 'Developer',
    email: 'john.doe@example.com',
    status: AccountStatus.ENABLED,
  },
  {
    id: 'emp-2',
    firstName: 'Jane',
    lastName: 'Smith',
    role: 'Designer',
    email: 'jane.smith@example.com',
    status: AccountStatus.ENABLED,
  },
];

export const MOCK_RESPONSE_GET_DEPARTMENT_TEAM_DETAILS: DepartmentTeamDetails = {
  id: 'team-1',
  name: 'Development Team',
  manager: {
    id: 'emp-1',
    firstName: 'John',
    lastName: 'Doe',
    role: 'Developer',
    email: 'john.doe@example.com',
    status: AccountStatus.ENABLED,
  },
  stats: {
    totalEmployees: 10,
    completedEmployees: 9,
    invalidEmployees: 1,
  },
};

export const MOCK_RESPONSE_GET_DEPARTMENTS_CREDITS = {
  organizationId: 'org-123',
  departmentId: 'dept-456',
  year: 2024,
  quarter: 1,
  stats: {
    employees: {
      total: 12,
    },
    assigned: 1000,
    used: 600,
    remaining: 400,
    utilizationPercentage: 60,
    usersCount: 12,
    clusterUsers: [
      {
        avgUsedCredits: 50,
        clusterName: ClusterType.INATTIVI,
        usersNumber: 5,
      },
    ],
    avgUsedPerPerson: 50,
    monthlyUsage: {
      '2025-01': 100.5,
      '2025-02': 120,
      '2025-03': 95.7,
    },
  },
  teams: [
    {
      teamId: 'team-1',
      teamName: 'Team Alpha',
      userNumber: 5,
      averageConsumption: 50,
      assigned: 70,
    },
    {
      teamId: 'team-2',
      teamName: 'Team Beta',
      userNumber: 3,
      averageConsumption: 30,
      assigned: 30,
    },
  ],
  createdAt: '2024-01-01T00:00:00Z',
};

export const MOCK_RESPONSE_GET_DEPARTMENT_TEAM_CREDITS = {
  organizationId: 'org-123',
  departmentId: 'dept-456',
  areaId: 'team-789',
  year: 2024,
  quarter: 1,
  stats: {
    employees: {
      total: 12,
    },
    assigned: 1000,
    used: 600,
    remaining: 400,
    utilizationPercentage: 60,
    usersCount: 12,
    clusterUsers: [
      {
        clusterName: ClusterType.INATTIVI,
        usersNumber: 5,
        avgUsedCredits: 50,
      },
    ],
    avgUsedPerPerson: 50,
    monthlyUsage: {
      '2025-01': 100.5,
      '2025-02': 120,
      '2025-03': 95.7,
    },
  },
  createdAt: '2024-01-01T00:00:00Z',
};

export const MOCK_RESPONSE_POST_CREATE_DEPARTMENT = undefined;

export const MOCK_RESPONSE_POST_ASSIGN_DEPARTMENT = undefined;

export const MOCK_RESPONSE_POST_ASSIGN_CHECK = { warnings: [] };

export const MOCK_RESPONSE_GET_DEPARTMENTS_CREDITS_QUARTER = [
  {
    quarter: '1',
    year: 2024,
  },
];

export const MOCK_RESPONSE_GET_DEPARTMENT_TEAM_CREDITS_QUARTER = [
  {
    quarter: '1',
    year: 2024,
  },
];
